import type { useModalController } from '@uikit';
import { Modal, ModalCloseButton, ModalContent, ModalHeading } from '@uikit';

import { CopyInput } from '@store:web/components/common/CopyInput';
import SocialShareList from '@store:web/components/common/ShareSocialsList/ShareSocialsList';
import type { PlatformConfiguration } from '@store:web/components/common/ShareSocialsList/utils';

export interface ShareModalProps {
  url: string;
  modalHeading: string;
  modalController: ReturnType<typeof useModalController>;
  platformConfigurations: PlatformConfiguration;
}

export default function ShareModal({
  url,
  modalHeading,
  modalController,
  platformConfigurations,
}: ShareModalProps) {
  return (
    <Modal {...modalController.props}>
      <ModalContent className="flex flex-col items-center p-0">
        <ModalCloseButton className="!m-4" />

        <div className="flex flex-col items-center gap-4 pt-0 px-4 sm:px-12 pb-6 sm:pb-12">
          <ModalHeading>{modalHeading}</ModalHeading>

          <CopyInput url={url} />

          <SocialShareList platformConfigurations={platformConfigurations} />
        </div>
      </ModalContent>
    </Modal>
  );
}
